import { Tracker } from '@pegasus/tracker';
import { CampaignEarlyAccessState, EarlyAccessPhase } from './types';
export var TRACK_EVENTS;
(function (TRACK_EVENTS) {
    TRACK_EVENTS["NOTIFICATION_PUSH_CLOSE"] = "notification_push_close";
    TRACK_EVENTS["NOTIFICATION_PUSH_CANCEL"] = "notification_push_cancel";
    TRACK_EVENTS["NOTIFICATION_PUSH_OPT_IN"] = "notification_push_optIn";
    TRACK_EVENTS["NOTIFICATION_PUSH_BLOCKED_CLOSE"] = "notification_push_blockedClose";
})(TRACK_EVENTS || (TRACK_EVENTS = {}));
export var tracker = new Tracker();
export var getEarlyAccessPhase = function (earlyAccessPhase) {
    switch (earlyAccessPhase) {
        case EarlyAccessPhase.BuildUp:
            return 'buildUp';
        case EarlyAccessPhase.PreEarlyAccess:
            return 'preEarlyAccess';
        case EarlyAccessPhase.EarlyAccess:
            return 'earlyAccess';
        case EarlyAccessPhase.GeneralAccess:
            return 'generalAccess';
        default:
            break;
    }
    return null;
};
export var getEarlyAccessTrackingPhase = function (_a) {
    var earlyAccessState = _a.earlyAccessState, earlyAccessPhase = _a.earlyAccessPhase;
    switch (earlyAccessState) {
        case CampaignEarlyAccessState.Active:
            return 'earlyAccess';
        case CampaignEarlyAccessState.Expired:
            return 'generalAccess';
        default:
            break;
    }
    if (earlyAccessPhase) {
        return getEarlyAccessPhase(earlyAccessPhase);
    }
    return null;
};
